import React, { useState } from "react";
import ReactDOM from "react-dom";
import { FaTimes, FaWallet, FaTag } from "react-icons/fa";
import { TopUpModal } from "./TopUpModal";
import paymentIcon from "../../../assets/images/switch_app.png";
import voucherIcon from "../../../assets/images/voucher.png";
import {
  TopUpOverlay,
  TopUpSheet,
  TopUpHandle,
  TopUpHeader,
  TopUpHeaderTop,
  TopUpTitle,
  TopUpCloseBtn,
  TopUpBalancePill,
  TopUpBody,
  TopUpMethodGrid,
  TopUpMethodCard,
  TopUpMethodIcon,
  TopUpMethodName,
  TopUpMethodDesc,
  TopUpFieldGroup,
  TopUpFieldLabel,
  TopUpFieldInput,
  TopUpAmountWrapper,
  TopUpAmountPrefix,
  TopUpAmountInput,
  TopUpFieldHint,
  TopUpFooter,
  TopUpSendButton,
  TopUpCancelBtn,
} from "../style";

const METHODS = [
  {
    key: 0,
    name: "Card / Transfer",
    desc: "Pay with SwitchApp",
    icon: paymentIcon,
    square: false,
  },
  {
    key: 1,
    name: "Voucher Code",
    desc: "Redeem a voucher",
    icon: voucherIcon,
    square: true,
  },
];

export const WalletModal = ({ reset }) => {
  const [show, setShow] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [form, setForm] = useState({ voucherCode: "", amount: "" });
  const [isLoading, setIsLoading] = useState(false);

  const handleOpen = () => setShow(true);

  const resetData = () => {
    setShow(false);
    setCurrentIndex(0);
    setForm({ voucherCode: "", amount: "" });
    reset();
  };

  const handleChange = (e) => {
    setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const isVoucher = currentIndex === 1;
  const canSubmit = isVoucher ? !!form.voucherCode.trim() : !!form.amount && +form.amount > 0;

  return (
    <>
      <button onClick={handleOpen}>Top up balance</button>

      {show && ReactDOM.createPortal(
        <TopUpOverlay onClick={resetData}>
          <TopUpSheet onClick={(e) => e.stopPropagation()}>
            <TopUpHandle />

            <TopUpHeader>
              <TopUpHeaderTop>
                <TopUpTitle>Add Funds</TopUpTitle>
                <TopUpCloseBtn onClick={resetData} disabled={isLoading}>
                  <FaTimes size={14} />
                </TopUpCloseBtn>
              </TopUpHeaderTop>
              <TopUpBalancePill>
                <span>Note</span>
                <span>200 Naira = 200 Units</span>
              </TopUpBalancePill>
            </TopUpHeader>

            <TopUpBody>
              <TopUpFieldGroup>
                <TopUpFieldLabel>Payment Method</TopUpFieldLabel>
                <TopUpMethodGrid>
                  {METHODS.map(({ key, name, desc, icon, square }) => (
                    <TopUpMethodCard
                      key={key}
                      type="button"
                      $active={currentIndex === key}
                      onClick={() => {
                        setCurrentIndex(key);
                        setForm({ voucherCode: "", amount: "" });
                      }}
                    >
                      <TopUpMethodIcon $active={currentIndex === key} $square={square}>
                        <img src={icon} alt={name} />
                      </TopUpMethodIcon>
                      <TopUpMethodName $active={currentIndex === key}>{name}</TopUpMethodName>
                      <TopUpMethodDesc>{desc}</TopUpMethodDesc>
                    </TopUpMethodCard>
                  ))}
                </TopUpMethodGrid>
              </TopUpFieldGroup>

              {isVoucher ? (
                <TopUpFieldGroup>
                  <TopUpFieldLabel>Voucher Code</TopUpFieldLabel>
                  <TopUpFieldInput
                    type="text"
                    name="voucherCode"
                    value={form.voucherCode}
                    onChange={handleChange}
                    placeholder="Enter your voucher code"
                    autoComplete="off"
                  />
                  <TopUpFieldHint>
                    You can enter multiple voucher codes separated by a comma.
                  </TopUpFieldHint>
                </TopUpFieldGroup>
              ) : (
                <TopUpFieldGroup>
                  <TopUpFieldLabel>Amount</TopUpFieldLabel>
                  <TopUpAmountWrapper>
                    <TopUpAmountPrefix>₦</TopUpAmountPrefix>
                    <TopUpAmountInput
                      type="number"
                      name="amount"
                      value={form.amount}
                      onChange={handleChange}
                      placeholder="0.00"
                      inputMode="decimal"
                      min="1"
                    />
                  </TopUpAmountWrapper>
                  <TopUpFieldHint>Minimum purchase is ₦5,000</TopUpFieldHint>
                </TopUpFieldGroup>
              )}
            </TopUpBody>

            <TopUpFooter>
              <TopUpModal
                currentIndex={currentIndex}
                form={form}
                handleClose={resetData}
                disabled={!canSubmit}
                isLoading={isLoading}
                setIsLoading={setIsLoading}
                renderButton={({ onClick, isLoading: loading }) => (
                  <TopUpSendButton onClick={onClick} disabled={!canSubmit || loading}>
                    {loading
                      ? "Please wait…"
                      : isVoucher
                      ? "Redeem Voucher"
                      : form.amount
                      ? `Pay ₦${Number(form.amount).toLocaleString()}`
                      : "Continue"}
                  </TopUpSendButton>
                )}
              />
              <TopUpCancelBtn onClick={resetData} disabled={isLoading}>
                Cancel
              </TopUpCancelBtn>
            </TopUpFooter>
          </TopUpSheet>
        </TopUpOverlay>,
        document.body
      )}
    </>
  );
};
